var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHalfFilledCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ox1uyzqlaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1024H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "21qebdsjmb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C0 4.478 4.478 0 10 0zm.025 1.335v17.33c4.767-.012 8.642-3.895 8.642-8.665s-3.875-8.653-8.642-8.665z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ox1uyzqlaa)",
    transform: "translate(-780 -440)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#21qebdsjmb)",
    transform: "translate(782 442)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD044",
    d: "M0 0h20v20H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHalfFilledCircle);
export default __webpack_public_path__ + "static/media/icon-half-filled-circle.d02f0a8b.svg";
export { ForwardRef as ReactComponent };